import { useDispatch } from "react-redux";
import { closeModal, registerModal } from "../../../../libs/modals";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../../../components/ui/dialog";

const DEMO_RECONNECT_NOTE =
  "This is a Sked Social demo account and cannot be reconnected. Use Demo Tools, Heal in the admin panel.";

export const DEMO_ACCOUNT_RECONNECT_NOTE = "DEMO_ACCOUNT_RECONNECT_NOTE";

function DemoAccountReconnectNote({ isHidden }: { isHidden?: boolean }) {
  const dispatch = useDispatch();
  return (
    <Dialog
      open={!isHidden}
      onOpenChange={(open) => {
        if (!open) dispatch(closeModal({ type: DEMO_ACCOUNT_RECONNECT_NOTE }));
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Demo account</DialogTitle>
          <DialogDescription>{DEMO_RECONNECT_NOTE}</DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

/**
 * Seeded demo accounts hold no token, so a reconnect can only mark them
 * failed. Reconnect entry points open this note for them instead.
 */
export const demoAccountReconnectNote = registerModal(
  DEMO_ACCOUNT_RECONNECT_NOTE,
  DemoAccountReconnectNote
);
